<template>
  <div class="login-container" v-loading="isLoading">
    <div class="title-box">
      <img :src="logo" class="logo-img" alt="" />
      <span class="logo">花源溪</span>
    </div>
    <div class="login" v-if="layoutLogin">
      <!-- <h1>后台管理系统 | 登录</h1> -->
      <div class="title">
        <img :src="logo" class="logo-img" alt="" />
        <span class="logo">花源溪</span>
      </div>
      <div class="tip">账号登录</div>
      <ul>
        <li>
          <!-- <p>账号：</p> -->
          <input v-model="loginData.username" placeholder="请输入账号" />
        </li>
        <li>
          <!-- <p>密码：</p> -->
          <input
            v-model="loginData.password"
            type="password"
            placeholder="请输入密码"
          />
        </li>
        <!-- <li>
                      <p>验证码：</p>
                      <input
                          v-model="loginData.code"
                          type="text"
                          placeholder="请输入图片中的内容"
                          class="captcha_input"
                          @keyup.enter="goLogin()"
                      />
                      <img
                          class="captcha_img"
                          :src="this.captchaImg"
                          alt=""
                          @click="getCaptchaImg"
                      />
                      <i class="el-icon-refresh-right" @click="getCaptchaImg"></i>
                  </li> -->
      </ul>

      <button class="login-btn" @click="goLogin">登录</button>
      <!-- <div style="color: #3c90fe;font-size: 14px;margin-top: 10px" @click="goChangePsw">修改密码</div> -->
    </div>
    <div class="login main" v-else>
      <h1>后台管理系统 | 修改密码</h1>
      <ul>
        <li>
          <p>账号</p>
          <input v-model="pswData.userName" placeholder="请输入账号" />
        </li>
        <li>
          <p>验证码</p>
          <input v-model="pswData.smsCode" placeholder="请输入验证码" />
          <el-button
            size="small"
            type="primary"
            style="width: 100px"
            :loading="pswData.btnLoading"
            v-text="pswData.hintTxt"
            @click="getUserPhone"
          ></el-button>
        </li>
        <li>
          <p>密码</p>
          <input
            v-model="pswData.psw"
            placeholder="请设置密码"
            type="password"
          />
        </li>
      </ul>
      <button class="login-btn" @click="changePsw">提交</button>
      <div
        style="color: #3c90fe; font-size: 14px; margin-top: 10px"
        @click="goToLogin"
      >
        登录
      </div>
    </div>
    <div class="bah" @click="toBah">
      <div style="margin:0 auto; padding:20px 0;">
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37010502001997"
          style="text-align: center;display:inline-block;text-decoration:none;height:20px;line-height:20px;"
          ><img :src="staticImg + 'beian.png'" style="float:left;" />
          <p
            style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 0px; color:#939393;"
          >
            鲁公网安备 37010502001997号
            <a
              target="_blank"
              href="https://beian.miit.gov.cn"
              style="text-align: center;"
              ><p style="padding-top: 3px;color:#939393;">
                备案号：鲁ICP备2023025137号-1
              </p></a
            >
          </p></a
        >
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapGetters, mapMutations } from 'vuex';
import { logo, staticImg } from '../config';
import JSEncrypt from 'jsencrypt';
import pubKey from '@/assets/js/pubKey.js';
export default {
  name: 'login',
  data() {
    return {
      captchaImg: '', // 图片验证码地址
      captchaId: '', // 图片验证码id
      inputSize: 'small',
      isLoading: false,
      btnTxt: '获取',
      layoutLogin: true,
      logo: logo,
      loginData: {
        username: '',
        password: '' // 密码
        // code: "", //图片验证码
      },
      pswData: {
        intervalId: '',
        userName: '',
        smsCode: '',
        hintTxt: '获取验证码',
        btnLoading: false,
        phone: '',
        psw: ''
      },
      staticImg: staticImg,
    };
  },
  created() {
    // this.getCaptchaImg();
    console.log('token', this.token);
    // if (this.token) {
    //     this.setMenu('1');
    //     this.$router.push({
    //         name: 'welcome'
    //     });
    // }
  },
  computed: {
    ...mapGetters(['token', 'userInfo'])
  },
  methods: {
    ...mapMutations(['setToken', 'setSys','setUser', 'setMenu', 'setBaseInfo']),

    // 登录
    goLogin() {
      if (this.loginData.username === '') {
        this.$message.error('请输入用户名');
        return false;
      }
      if (this.loginData.password === '') {
        this.$message.error('请输入密码');
        return false;
      }
      if (this.loginData.code === '') {
        this.$message.error('请输入图片验证码');
        return false;
      } else {
        // let data = {
        //   ...this.loginData,
        //   captcha_id: this.captchaId
        // };
        let time = (+new Date() + '').substr(0, 10);
              let pass = this.rsa(`${this.loginData.password}\\n${time}\\n`);
        this.httpPost(this.$root.manageLogin, {
          phone: this.loginData.username,
          password: pass,
          timestamp: time
        }).then(
          (res) => {
            // token存本地
            console.log('2222222', res);
            this.setToken(res.token);
            this.setUser(res.info);
            this.setSys(res.sys);
            this.setMenu('0-0');
            // this.getInfo();
            if(res.sys > 0){
              this.$router.push({
                name: 'SubIndex'
              });
            } else {
              this.$router.push({
                name: 'index'
              });
            }
          },
          (err) => {
            // this.getCaptchaImg();
            this.$message.error(err);
            // if (err == '验证码错误' || err == '参数有误' ) {
            //     this.$message.error('登录失败，验证码错误！')
            // } else {
            //     this.$message.error('登录失败，您输入的账号密码不正确！')
            // }
          }
        );
      }
    },
    // 获取图片验证码
    getCaptchaImg() {
      this.httpGet(this.$root.getCaptchaImg).then((res) => {
        this.captchaImg = res.data;
        this.captchaId = res.id;
      });
    },
    getInfo() {
      // 获取商城基础信息
      this.$router.push({
        name: 'index'
      });
      // this.httpPost(this.$root.baseInfo).then(res => {
      //     // 存本地
      //     this.setBaseInfo(res.base_info);
      //     this.$router.push({
      //         name: 'welcome'
      //     });
      // }, () => {
      // });
    },
    // 修改密码
    // goChangePsw() {
    //     this.layoutLogin = false;
    // },
    // 获取手机号
    getUserPhone() {
      // 登录
      this.pswData.btnLoading = true;
      this.httpPost(this.$root.getUserPhone, {
        uname: this.pswData.userName
      }).then(
        (res) => {
          this.pswData.btnLoading = false;
          this.pswData.phone = res.phone;
          if (res.phone === null) {
            this.$message.error('手机号不存在');
          } else {
            this.getSmsCode();
          }
        },
        () => {
          this.pswData.btnLoading = false;
        }
      );
    },
    // 获取手机验证码
    getSmsCode() {
      this.pswData.btnLoading = true;
      this.httpPost(this.$root.getSmsCode, {
        phone: this.pswData.phone,
        type: 12
      }).then(
        (res) => {
          this.pswData.btnLoading = false;
          this.countDown(60);
        },
        () => {
          this.pswData.btnLoading = false;
        }
      );
    },
    // 修改密码
    changePsw() {
      if (!this.verifyData()) {
        return;
      }

      this.isLoading = true;
      this.httpPost(this.$root.changePsw, {
        phone: this.pswData.phone,
        type: 12,
        code: this.pswData.smsCode,
        uname: this.pswData.userName,
        password: this.pswData.psw
      }).then(
        (res) => {
          this.isLoading = false;
          this.$message({
            message: '设置成功',
            type: 'success'
          });
          this.goToLogin();
        },
        () => {
          this.isLoading = false;
        }
      );
    },
    // 短信验证码倒计时
    countDown(sec) {
      console.log('start');
      let secNum = sec;
      this.pswData.intervalId = setInterval(() => {
        secNum--;
        if (secNum <= 0) {
          clearInterval(this.pswData.intervalId);
          this.pswData.btnLoading = false;
          this.pswData.hintTxt = '获取验证码';
          console.log('finish');
        } else {
          this.pswData.btnLoading = true;
          this.pswData.hintTxt = secNum + 's';
          console.log('' + secNum);
        }
      }, 1000);
    },
    goToLogin() {
      this.layoutLogin = true;
    },
    // 修改密码校验表单输入
    verifyData() {
      if (this.pswData.userName === '') {
        this.$message.error('请输入用户名');
        return false;
      }
      if (this.pswData.smsCode === '') {
        this.$message.error('请输入验证码');
        return false;
      }
      if (this.pswData.psw === '') {
        this.$message.error('请输入密码');
        return false;
      }
      return true;
    },
    rsa(pass) {
        console.log('加密前', pass)
        var encryptor = new JSEncrypt() // 创建加密对象实例
        encryptor.setPublicKey(pubKey) //设置公钥
        return encryptor.encrypt(pass) || '加密失败'
    },
    toBah(){
      window.open("https://beian.miit.gov.cn")
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

::-webkit-input-placeholder {
  color: gray9;
}

.el-icon-refresh-right {
  font-size: 20px;

  &:hover {
    cursor: pointer;
  }
}

.captcha_input {
  width: 175px;
  font-size: word16;
  line-height: 40px;
  height: 40px;
  outline: none;
}

.captcha_img {
  width: 102px;
  height: 41px;
}

.login-container {
  flex-y(flex-start);
  width: 100%;
  height: 100%;
  // background: white;
  background: url('https://iry-img.datouit.com/static/bg.png') no-repeat;
  background-size: cover;
}

.title-box {
    flex-x(center, center);
    word(40px, #333);
    font-weight: 700;
    align-self: flex-start;
    margin-top: 36px;
    margin-left: 56px;

    .logo-img {
      height: 50px;
      width: auto;
      margin-right: 16px;
    }
  }

.login {
  width: 434px;
  height: 420px;
  background: #F6F6F6;
  border-radius: 20px;
  flex-y(flex-start);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10%;
  padding-top: 35px;

  .el-checkbox__label {
    font-size: 14px;
  }

  .title {
    flex-x(center, center);
    word(24px, #333);
    font-weight: 700;

    .logo-img {
      height: 30px;
      width: auto;
      margin-right: 8px;
    }
  }

  .tip{
    width: 360px;
    margin-top: 50px;
    word(14px, #333);
    font-weight: 700;
  }

  ul {
    width: 360px;
  }

  h1 {
    font-size: 24px;
    margin-bottom: 20px;
  }

  li {
    height: 40px;
    line-height: 40px;
    margin-top: 24px;
    // bor-bottom();
    flex-x(flex-start);

    p {
      width: 100px;
      font-size: word18;
    }

    span {
      margin-right: 10px;
    }

    input {
      font-size: word16;
      line-height: 40px;
      height: 40px;
      width: 100%;
      outline: none;
      border: 1px solid #C2C6CE;
      border-radius: 4px;
      padding: 0 12px;
      word(14px, #333);
    }
  }

  .forget {
    width: 100%;
    height: 50px;
    line-height: 50px;
    flex-x();

    .el-checkbox__inner {
      width: 16px;
      height: 16px;
      border(gray3);
    }
  }

  .login-btn {
    login-btn();
    font-size: 14px;
    font-weight: 700;
    width: 360px;
    margin-top: 50px;
    border-radius: 4px;
  }

  .bot-btn {
    margin-top: 10px;
    color: gray3;
    font-size: 16px;

    a {
      color: blue;
    }
  }
}

.el-button--primary {
  width: 100%;
  margin: 20px 0;
}

#app .el-input__inner {
  border: none;
}

.el-input {
  border: none;
}
.bah{
  position: absolute;
  bottom: 16px;
  word(14px, #333);
  cursor: pointer;
}
</style>
